<template>
    <div>
        <Sidebar :visible.sync="exibirSideBar" position="full">    
            <Card>
                <template #title>Incluir Solicitação</template>
                <template #subtitle>{{ subTitulo }}</template>
                <template #content >                  
                    <div class="p-fluid p-formgrid p-grid" v-if="ponto && tipoForm == 'JUSTIFICAR_PONTO'">
                        <div class="p-field p-col-12 p-md-12">
                            <label>Ocorrência</label>
                            <Dropdown v-model="idDivergenciaSelecionada" :options="ponto.divergencias" 
                            optionLabel="descricao" optionValue="id" placeholder="Selecione"/>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <label>Justificativa</label>
                            <Dropdown v-model="idJustificativaSelecionada" :options="justificativasGerais" 
                            optionLabel="descricao" optionValue="id" placeholder="Selecione"/>
                        </div>	
                    </div>    
                    <div class="p-fluid p-formgrid p-grid" v-if="ponto && tipoForm == 'INCLUIR_MARCACAO'">
                        <div class="p-field p-col-12 p-md-12">
                            <label>Horário</label>
                            <Calendar v-model="horario" :timeOnly="true" hourFormat="24" />
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <label>Justificativa</label>
                            <Dropdown v-model="idJustificativaMarcacaoSelecionada" :options="justificativasMarcacoes" 
                            optionLabel="descricao" optionValue="id" placeholder="Selecione"/>
                        </div>	
                    </div>              
                </template>
                <template #footer>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-col">
                            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirSideBar=false" />
                        </div>
                        <div class="p-col">
                            <Button label="Enviar" icon="pi pi-check" @click="enviar" />
                        </div>
                    </div>
                </template>
            </Card>       
        </Sidebar>    

        <Dialog :visible.sync="exibirModalSucesso" header="Incluir Solicitação" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">      
                <Message severity="success" :closable="false"><span style="font-size: 16px;">Aguarde!</span></Message>         
                <p>Solicitação enviada com sucesso. Status <b>Pendente de Aprovação</b>.</p>
            </div>
            <template #footer>       
                <Button label="OK" icon="pi pi-check" @click="exibirModalSucesso=false" />
            </template>
        </Dialog>

    </div>
</template>

<script>
import PontoService from '@/service/PontoService';
import { mapGetters, mapActions } from 'vuex';
import { exibirMensagem, exibirMensagemSis } from '@/global';

export default {   
    pontoService: null, 
    data() {
        return {
            exibirSideBar: false,
            exibirModalSucesso: false,        
            justificativasGerais: [],
            justificativasMarcacoes: [],
            idDivergenciaSelecionada: null,
            idJustificativaSelecionada: null,
            idJustificativaMarcacaoSelecionada: null,
            tipoForm: '',
            subTitulo: '',
            mesAno: null,
            horario: null,
            ponto: null
        }
    },
    methods: {
        ...mapGetters('sessao', ['getUsuario']),
        ...mapActions('sessao', ['limparSessao']), 
        /**
         *      
         */
        exibirIncluirMarcacao(ponto, mesAno, justificativasMarcacoes) {
            if(!ponto || !ponto.id 
                || (ponto.observacao && ponto.observacao == 'Folga')) {
                return;
            }           
            this.horario = null;
            this.idJustificativaMarcacaoSelecionada = null;
            this.mesAno = mesAno;
            this.ponto = ponto;
            this.justificativasMarcacoes = justificativasMarcacoes;
            this.tipoForm = 'INCLUIR_MARCACAO';
            this.subTitulo = 'Marcação - ' + this.formatarDataPtBr(ponto.dia);
            this.exibirSideBar = true;
        },
        /**
         *        
         */
        exibirJustificarPonto(ponto, mesAno, justificativasGerais) {
            if(!ponto || !ponto.id 
                || ponto.divergencias.length == 0
                || (ponto.observacao && ponto.observacao == 'Folga')) {
                return;
            }
            this.idDivergenciaSelecionada = null;
            this.idJustificativaSelecionada = null;         
            this.mesAno = mesAno;
            this.ponto = ponto;
            this.justificativasGerais = justificativasGerais;       
            this.tipoForm = 'JUSTIFICAR_PONTO';
            this.subTitulo = 'Justificar Ponto - ' + this.formatarDataPtBr(ponto.dia);
            this.exibirSideBar = true;
        },
        /**
         * 
         */
        enviar() {
            if(this.tipoForm == 'INCLUIR_MARCACAO') {
                this.incluirMarcacao();
            } else if(this.tipoForm == 'JUSTIFICAR_PONTO') {
                this.justificarPonto();
            }
        },
        /**
         * 
         */
        incluirMarcacao() {
            if(!this.horario || !this.idJustificativaMarcacaoSelecionada) {
                exibirMensagemSis(this, 'Informe a hora e selecione uma justificativa', true);
                return;
            }        
            let h = this.horario.getHours() < 10 ? '0' + this.horario.getHours() : this.horario.getHours();
            let m = this.horario.getMinutes() < 10 ? '0' + this.horario.getMinutes() : this.horario.getMinutes();
            let usuario = this.getUsuario();
            let requisicao = {
                id: usuario.id,
                idPonto: this.ponto.id,
                data: this.ponto.dia,
                hora: h + ':' + m,
                idJustificativa: this.idJustificativaMarcacaoSelecionada,
                numeroCnpj: usuario.numeroCnpj,
                grupo: usuario.grupo,
                mes: this.mesAno.getMonth() + 1,
                ano: this.mesAno.getFullYear(),
                tipoDispositivo: 'Web'
            };
            this.pontoService.incluirMarcacao(requisicao)
            .then(resp => {
                exibirMensagem(this, resp);
                this.exibirSideBar = false;
                this.exibirModalSucesso = true;
            })
            .catch(erro => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {
                    exibirMensagem(this, erro)
                }  
            });             
        },
        /**
         * 
         */
        justificarPonto() {
            if(!this.idDivergenciaSelecionada || !this.idJustificativaSelecionada) {
                exibirMensagemSis(this, 'Selecione uma ocorrência e uma justificativa', true);
                return;
            }  
            let codigoDivergencia = -1;
            this.ponto.divergencias.forEach(diverg => {
                if(diverg.id == this.idDivergenciaSelecionada) {
                    codigoDivergencia = diverg.codigo;
                }
            });
            let usuario = this.getUsuario();
            let requisicao = {
                id: usuario.id,              
                idDivergencia: this.idDivergenciaSelecionada,
                idJustificativa: this.idJustificativaSelecionada,
                codigoDivergencia: codigoDivergencia,              
                grupo: usuario.grupo,
                mes: this.mesAno.getMonth() + 1,
                ano: this.mesAno.getFullYear(),
                tipoDispositivo: 'Web'
            };
            this.pontoService.justificar(requisicao)
            .then(resp => {
                exibirMensagem(this, resp);
                this.exibirSideBar = false;
                this.exibirModalSucesso = true;
            })
            .catch(erro => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {
                    exibirMensagem(this, erro)
                }  
            });
        },
        /**
         * 
         */
        formatarDataPtBr(data) {
            let partes = data.split('-');
            return partes[2] + '/' + partes[1] + '/' + partes[0];
        },
        /**
         * 
         */
        logout() {
          this.limparSessao();			
          this.$router.push('/login?exp=sessao_expirada');
        } 
    },
    created() {
        this.pontoService = new PontoService();
    }
}

</script>